var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"files-view-container",attrs:{"fluid":""}},[_c('h1',[_vm._v("Files")]),_vm._v(" "),_c('files-table',{attrs:{"files":_vm.files,"loading":_vm.loading},on:{"refreshFileTable":_vm.refreshFiles}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98ea5dc0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/financialProducts/Files.vue
// module id = null
// module chunks = 